// extracted by mini-css-extract-plugin
module.exports = {"block":"block___uFOWc"};